import type { Subcategory } from '~/entities/categories'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { getDocumentStep } from './get-document-step'

export function getIsClusteringFinished(
  document: apiClient.Document,
  subcategories: Subcategory[],
): boolean {
  return [
    'classification',
    'data',
    'carc_rarc',
    'patient',
    'eob_payment_deposit',
    'eob_duplication',
    'eob_processing',
    'finished',
  ].includes(getDocumentStep(document, subcategories))
}

export function getIsClassificationFinished(
  document: apiClient.Document,
  subcategories: Subcategory[],
): boolean {
  return [
    'data',
    'carc_rarc',
    'patient',
    'eob_payment_deposit',
    'eob_duplication',
    'eob_processing',
    'finished',
  ].includes(getDocumentStep(document, subcategories))
}

export function getIsDataExtractionFinished(
  document: apiClient.Document,
  subcategories: Subcategory[],
): boolean {
  return ['carc_rarc', 'patient', 'finished'].includes(getDocumentStep(document, subcategories))
}

export function getIsTaggingFinished(
  document: apiClient.Document,
  subcategories: Subcategory[],
): boolean {
  return ['patient', 'finished'].includes(getDocumentStep(document, subcategories))
}

export function getIsTaggingStepReviewed(document: apiClient.Document): boolean {
  return (
    document.reviewed_step === 'carc_rarc' ||
    document.reviewed_step === 'patient' ||
    document.review_status === 'reviewed' ||
    document.review_status === 'auto_reviewed'
  )
}

export function getIsPatientFinished(
  document: apiClient.Document,
  subcategories: Subcategory[],
): boolean {
  return ['finished'].includes(getDocumentStep(document, subcategories))
}

export function getIsPaymentDepositFinished(
  document: apiClient.Document,
  subcategories: Subcategory[],
): boolean {
  return ['eob_duplication', 'eob_processing', 'finished'].includes(
    getDocumentStep(document, subcategories),
  )
}

export function getIsDuplicationFinished(
  document: apiClient.Document,
  subcategories: Subcategory[],
): boolean {
  return ['eob_processing', 'finished'].includes(getDocumentStep(document, subcategories))
}

export function getIsEobProcessingFinished(
  document: apiClient.Document,
  subcategories: Subcategory[],
): boolean {
  return ['finished'].includes(getDocumentStep(document, subcategories))
}
